import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { GetPostApiParam } from '../models/intake/intakeMedication';

@Injectable({
  providedIn: 'root'
})
export class IntakeSocialService {
  constructor(private genericService: GenericUtilityService) { }
  GetPatientSocialHistory(patientAccount:any,practiceCode:any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetSocialHistory?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount);
}
SavePatientSocialHistory(data: any) {
  return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SavePatientSocialHistory", data);
}
}
